import APP_CONST from '../../constants';
import FourOFourPage from './404';

export default {
  	name: '404',
  	url: '/404',
  	component: FourOFourPage,
  	layout: APP_CONST.LAYOUT_PARTIAL
};